import {Condition, Event, Validation} from '@/model/types';
import {ALL_W_ARRAYS, W_Array} from '../src/sections/section-w/constants';
import {clearEntries} from './actions/array';
import {batchUnset} from './actions/fields';
import {Conditions} from './conditions';

export const W_INVESTMENT_SUM_FIELD = 'W11';

export const clearSectionW = [
  ...batchUnset([W_INVESTMENT_SUM_FIELD]),
  clearEntries(ALL_W_ARRAYS),
] as const satisfies Event[];

export const hasAnyOfAccountType = (array: W_Array): Condition => {
  return Conditions.array.for(array).rowCount.gt(0, false);
};

export const hasMaxOfAccountType = (array: W_Array, max: number): Condition => {
  return Conditions.array.for(array).rowCount.gte(max, false);
};

export const hasAtLeastNOfAccountType = (array: W_Array, n: number): Condition => {
  return Conditions.array.for(array).rowCount.gte(n, false);
};

export const hasMaxAccountOfAnyType = (max: number): Condition => {
  return Conditions.array.for(...ALL_W_ARRAYS).rowCount.gte(max, false);
};

export const hasNoAccountOfAnyType = (): Condition => {
  return Conditions.array.for(...ALL_W_ARRAYS).rowCount.equal(0, false);
};

export const hasReachedMaxTotalPercentage = Conditions.fields.gte('W11', 100);

export const assertMinimumOnePercent = {
  type: 'minEqual',
  value: 1,
} as const satisfies Validation;

export const assertNotReachedMaxSumPercentage = {
  type: 'maxSum',
  fields: ['W1#*', 'W5#*', 'W10#*', 'W12#*', 'W15#*'],
  value: 100,
  error: {
    fr: 'La valeur totale des pourcentages doit équivaloir à 100%',
    en: 'The percentages must add up to 100%',
  },
} as const satisfies Validation;
